import React from 'react';
import { modes } from '@comall-backend-builder/types';
import { get } from 'lodash';
import { PageTemplateSelector } from '../../../components';

export class PageTemplateMode extends modes.ObjectMode {
    /**
     * 获取有数据状态展示组件
     */
    getAvailableDisplayComponent(value: any, displayInfo: any) {
        const { className, style } = displayInfo;
        return (
            <span className={className} style={style}>
                {get(value, 'name')}
            </span>
        );
    }

    /**
     * 获取展示组件
     */
    getDisplayComponent(value: any, displayInfo: any) {
        if (value === undefined || value === null) {
            return this.getNotAvailableDisplayComponent(displayInfo);
        } else {
            return this.getAvailableDisplayComponent(value, displayInfo);
        }
    }

    /**
     * 获取输入组件
     */
    getControlComponent(controlInfo: any) {
        return <PageTemplateSelector {...controlInfo}></PageTemplateSelector>;
    }
}
